// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__oYeBD","main":"Footer_main__70Wfq","login":"Footer_login__VO0zy","links":"Footer_links__LU3rK","version":"Footer_version__hHtXZ"};